import { flow } from 'lodash';
import SelectObject from './SelectObject';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';
// import { withRouter } from 'react-router-dom';

export default flow(
  withUserInput,
  withValidation
)(SelectObject);



// WEBPACK FOOTER //
// ../core/src/components/SelectObject/index.js